import {
  IDeleteOfferFromFavoritesResponse,
  IDeleteOfferFromFavoritesResponse200,
} from '../../../../repositories/favorites/v1/delete-offer-from-favorites';

export const mapDeleteFavoriteResponse = (
  response: IDeleteOfferFromFavoritesResponse,
): IDeleteOfferFromFavoritesResponse200 => {
  return {
    statusCode: 200,
    headers: [],
    response,
  };
};
